import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import KeyboardArrowDownSharpIcon from '@material-ui/icons/KeyboardArrowDownSharp';

import { Box, MenuItem, Select } from '@material-ui/core';
import { getStaticText } from '../../../../utils/constants';
import { getEEBoxStyle } from '../../../../utils/functions';
import FilterSvg from '../../assets/Filter.svg';
import ActiveFilters1 from '../../assets/ActiveFilters1.svg';
import getStaticTextDiagnose from '../../constants';
import { getIndExpSectionHeading, isIndExpSubTabHidden } from '../indExperiencePublicSector';
import DownloadMenu from '../DownloadMenu';
import Excel from './Excel';

const showProgress = (value, background, isNegative, applyEx, key, isTopQuartile, isPercentile, isNonProfit, ohid) => {
    const { positiveBg = '#000000', negativeBg = '#ffffff' } =
        getEEBoxStyle(value, isNegative, isNonProfit, ohid) || {};
    const noBmBg = isNegative ? negativeBg : positiveBg;
    const bgToUse = applyEx ? background : noBmBg;
    const isEnps = key === 'enps' && applyEx && !isPercentile;
    const percentage = isEnps ? ((value + 100) * 100) / 200 : value;
    const progessStyle = {
        background: `
                    radial-gradient(closest-side, #ffffff 65%, transparent 0% 100%),
                    conic-gradient(${bgToUse} ${percentage}%, rgb(239, 238, 239) 0%)`,
    };
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <div className="progress-bar" style={progessStyle}>
                <progress value={value} min="0" max="100" style={{ height: 0, width: 0 }} />
                <div className="percentValue">{`${isEnps ? value : `${value}%`}`}</div>
                {isTopQuartile && applyEx ? <div className="triangle" /> : null}
            </div>
        </Box>
    );
};

function OrgHealth({
    defaultSettings,
    orgHealth,
    singleQuestion,
    getOrgHealthData,
    filterParams,
    orgHealthFetched,
    errorInfo,
    addOnTab,
    setAddOnTabs,
    appliedFiltersInfo,
    toggleFilterView,
    pptDownload,
    activeResetFilter,
    crossTabDemo,
    setCrossTabDemo,
    appliedBenchmark,
    filters,
}) {
    const {
        lang,
        ohid,
        threshold,
        engagement = '',
        quartileColors = [],
        apply_employee_exp_benchmark = false,
        report_type = '',
        is_public_sector_ohi = false,
    } = defaultSettings || {};
    const staticText = getStaticText(lang);
    const { SITE_TEXT, DEEP_DIVE_TYPE, NEG_IND_QUES, DEEP_DIVE_TYPE_EX } = staticText;
    const staticTextDiagnose = getStaticTextDiagnose(lang);
    const { IE_CROSSTAB_OPTIONS } = staticTextDiagnose;
    const {
        QUESTION_HEAD,
        OVERALL_SCORED,
        RESPONDENTS_WHO_RESPONDED,
        PERCEIVE_THE_ORGANIZATION_AS,
        HEALTHY,
        UNHEALTHY,
        EXRTREMELY_LIKELY,
        AGREE_OR_HIGHER,
        IND_EXP_LINKS,
        FILTERS,
        NUMBER_OF_RESPONDENTS_N,
        EMPLYEE_EXPEIENCE,
        NON_PROFIT_SURVEY,
        ADDITIONAL_PRACTICES,
    } = SITE_TEXT || {};
    const sectionHeading = getIndExpSectionHeading(is_public_sector_ohi, EMPLYEE_EXPEIENCE, ADDITIONAL_PRACTICES);

    const { records = {} } = orgHealth || {};
    const { qbyq = {} } = singleQuestion || {};
    const { records: qbyqRecords = {}, size = '' } = qbyq || {};
    const isNonProfit = engagement === NON_PROFIT_SURVEY;
    const [dwnldDrop, showDwnldDrop] = useState(false);
    const [selectedDownload, setSelectedDownload] = useState('');

    const formattedNumber = num => num.toString().replace(/^0/, '');

    useEffect(() => {
        if (!orgHealthFetched) {
            getOrgHealthData({ ohid, lang, threshold, filters: filterParams });
        }
        // eslint-disable-next-line
    }, [orgHealthFetched]);

    return (
        <div className="scoreBoard addOns clearfix">
            <div className="indExpBoard">
                <div className="rightScorecardHeader">
                    <div className="scorecardHeading">
                        <div className="mainHeading">{sectionHeading}</div>
                        <div className="nRes">
                            {NUMBER_OF_RESPONDENTS_N} : <span>{size.toLocaleString('en-US')}</span>
                        </div>
                    </div>
                    <ul className="navScoreList">
                        {!errorInfo && (
                            <DownloadMenu
                                lang={lang}
                                dwnldDrop={dwnldDrop}
                                showDwnldDrop={showDwnldDrop}
                                onPpt={pptDownload}
                                onExcel={() => {
                                    setSelectedDownload('excel');
                                    setTimeout(() => setSelectedDownload(''));
                                }}
                            />
                        )}
                        <li onClick={() => toggleFilterView(true)} data-testid="filterButton">
                            <img src={activeResetFilter ? ActiveFilters1 : FilterSvg} alt="" />
                            <span className="filter">{FILTERS}</span>
                        </li>
                    </ul>
                </div>
                {appliedFiltersInfo()}
                {appliedBenchmark()}

                <div className={`optionWrapper ${addOnTab === 1 ? 'stickyTop' : ''}`}>
                    <div>
                        <ul className="leftNav">
                            {IND_EXP_LINKS.map((tabName, index) => {
                                if (
                                    isIndExpSubTabHidden(index, is_public_sector_ohi) ||
                                    (!apply_employee_exp_benchmark && index === 4)
                                )
                                    return null;
                                return (
                                    <li
                                        data-testid={tabName}
                                        key={tabName}
                                        className={c({ activeLink: addOnTab === index })}
                                        onClick={() => setAddOnTabs(index)}
                                    >
                                        {tabName}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className="deepDiveHeading">
                    {IE_CROSSTAB_OPTIONS.filter(({ code }) => code === crossTabDemo)[0].label} <sup>1</sup>
                </div>
                <div className="buttonWrapper">
                    <div className="buttonContent" />
                    <div className="rightOptions">
                        <span>
                            <Select
                                IconComponent={KeyboardArrowDownSharpIcon}
                                value={crossTabDemo}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    getContentAnchorEl: null,
                                }}
                                onChange={({ target: { value: code } }) => setCrossTabDemo(code)}
                            >
                                {IE_CROSSTAB_OPTIONS.map(({ label, code, nonProfitAccess }) => {
                                    if (nonProfitAccess && isNonProfit) {
                                        return null;
                                    }

                                    return (
                                        <MenuItem classes={{ root: 'demographicOptions' }} key={code} value={code}>
                                            {label}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </span>
                    </div>
                </div>
                <div className="demographicBoard orgHealthBoard clearfix clearPadding">
                    <div className="orgHealth">
                        <div className="orgHealthHeader">
                            <div className="col1">{QUESTION_HEAD}</div>
                            <div className="col2">{OVERALL_SCORED}</div>
                            <div className="col3">{RESPONDENTS_WHO_RESPONDED} …</div>
                            <div className="col4" />
                            <div className="col5">
                                …{PERCEIVE_THE_ORGANIZATION_AS}… <br />
                                <ul className="clearfix">
                                    <li>
                                        {' '}
                                        <span className="color healthy" />
                                        {HEALTHY}
                                    </li>
                                    <li>
                                        <span className="color unhealthy" />
                                        {UNHEALTHY}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="orgHealthBody">
                            {Object.keys(records).map((key, i) => {
                                const { corelation, healthy, unhealthy } = records[key] || {};
                                const objToUse =
                                    key === 'enps' ? qbyqRecords.endorsing_organization_to_others : qbyqRecords[key];
                                const { meta_scores, score = '', quartile = '' } = objToUse || {};
                                const { qtext: question = '' } = meta_scores[0] || {};
                                const { background = '#ffffff' } = quartileColors[quartile] || {};
                                const sup = !apply_employee_exp_benchmark
                                    ? DEEP_DIVE_TYPE[question]
                                    : DEEP_DIVE_TYPE_EX[question];
                                const negativeTrait = NEG_IND_QUES.includes(key);
                                return (
                                    <div className="body" key={key}>
                                        <div className="col1">
                                            {question}
                                            <sup>{sup}</sup>
                                        </div>
                                        <div className="col2 percentProgress">
                                            {showProgress(
                                                score,
                                                background,
                                                negativeTrait,
                                                apply_employee_exp_benchmark,
                                                key,
                                                parseInt(quartile, 10) === 0,
                                                report_type === 'percentile',
                                                isNonProfit,
                                                ohid
                                            )}
                                        </div>
                                        <div className="col3">
                                            {i === 1 ? `"9" or "10" (${EXRTREMELY_LIKELY})` : `"4" ${AGREE_OR_HIGHER}`}
                                        </div>
                                        <div className="col4">
                                            r<sub>xy</sub>={formattedNumber(corelation)}{' '}
                                            <sup> {apply_employee_exp_benchmark ? 3 : 4}</sup>
                                        </div>
                                        <div className="col5">
                                            <div className="metaScore">
                                                <div className="chart">
                                                    <span
                                                        className={c({
                                                            gray: key !== 'intent_to_leave',
                                                            negative: true,
                                                        })}
                                                        style={{
                                                            width: `${unhealthy}%`,
                                                        }}
                                                    >
                                                        {formattedNumber(unhealthy)}
                                                    </span>
                                                </div>
                                                <div className="chart">
                                                    <span
                                                        className={c({ gray: key === 'intent_to_leave' })}
                                                        style={{
                                                            width: `${healthy}%`,
                                                        }}
                                                    >
                                                        {formattedNumber(healthy)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {selectedDownload === 'excel' ? (
                <Excel
                    variant="orgHealth"
                    filters={filters}
                    defaultSettings={defaultSettings}
                    crossTabDemo={crossTabDemo}
                    crossTabLabel={(IE_CROSSTAB_OPTIONS.find(({ code }) => code === crossTabDemo) || {}).label}
                    orgHealth={orgHealth}
                    singleQuestion={singleQuestion}
                    setSelectedDownload={setSelectedDownload}
                />
            ) : null}
        </div>
    );
}

OrgHealth.propTypes = {
    defaultSettings: PropTypes.object.isRequired,
    orgHealth: PropTypes.object.isRequired,
    singleQuestion: PropTypes.object.isRequired,
    getOrgHealthData: PropTypes.func.isRequired,
    filterParams: PropTypes.array.isRequired,
    orgHealthFetched: PropTypes.bool.isRequired,
    errorInfo: PropTypes.string.isRequired,
    addOnTab: PropTypes.number.isRequired,
    setAddOnTabs: PropTypes.func.isRequired,
    appliedFiltersInfo: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    pptDownload: PropTypes.func.isRequired,
    activeResetFilter: PropTypes.bool.isRequired,
    setCrossTabDemo: PropTypes.func.isRequired,
    crossTabDemo: PropTypes.string.isRequired,
    appliedBenchmark: PropTypes.func.isRequired,
    filters: PropTypes.array,
};

OrgHealth.defaultProps = {
    filters: [{ demographics: [], benchmarks: [], ex_benchmarks: [] }],
};

export default OrgHealth;
